<template lang="pug">
.answers.answers-choose-one
	bunt-button.answer(v-for="option in question.answer.options", @click="$store.dispatch('anwserCurrentQuestion', option.value)") {{ option.text }}
</template>
<script>
export default {
	components: {},
	props: {
		question: Object
	}
}
</script>
<style lang="stylus">
@import '~settings'
.questionnaire-form .step .answers-choose-one
	display: flex
	flex-direction: column
	.answer
		margin: 16px
		button-style(color: $clr-primary, size: 'large')
</style>
